<template>
  <main class="rh-invite">
    <div class="rh-panel">
      <img :src="logo" alt="MetaVirtue" class="rh-logo" />
      <div v-if="concluido" class="rh-success">
        <b-icon icon="check-circle-outline" size="is-large"></b-icon>
        <h1>Acesso criado</h1>
        <p>Sua senha foi definida. Entre para começar a usar o MetaVirtue.</p>
        <router-link to="/rh" class="button is-primary">Ir para o login</router-link>
      </div>
      <div v-else>
        <p class="rh-kicker">BEM-VINDO À PLATAFORMA</p>
        <h1>Ative seu convite</h1>
        <p>Defina uma senha segura para acessar sua equipe.</p>
        <b-message v-if="erro" type="is-danger">{{ erro }}</b-message
        ><ValidationObserver v-slot="{ handleSubmit }" slim
          ><form @submit.prevent="handleSubmit(aceitar)">
            <ValidationProvider v-slot="{ errors }" name="Senha" rules="required|min:12" vid="senha"
              ><b-field label="Senha" :type="errors.length ? 'is-danger' : ''" :message="errors[0]"
                ><b-input
                  v-model="senha"
                  type="password"
                  password-reveal
                  autocomplete="new-password"
                  placeholder="Ao menos 12 caracteres, letras e números"
                ></b-input></b-field></ValidationProvider
            ><ValidationProvider v-slot="{ errors }" name="Confirmação" rules="required|confirmed:senha"
              ><b-field label="Confirme a senha" :type="errors.length ? 'is-danger' : ''" :message="errors[0]"
                ><b-input
                  v-model="confirmacao"
                  type="password"
                  password-reveal
                  autocomplete="new-password"
                ></b-input></b-field></ValidationProvider
            ><b-button type="is-primary" native-type="submit" expanded :loading="salvando" :disabled="!token"
              >Ativar acesso</b-button
            >
          </form></ValidationObserver
        >
      </div>
    </div>
  </main>
</template>
<script>
import http from '@/http'
import logo from '@/assets/rh_logo.png'
export default {
  name: 'RhAceitarConvite',
  data() {
    return { logo, token: '', senha: '', confirmacao: '', salvando: false, concluido: false, erro: '' }
  },
  created() {
    this.token = decodeURIComponent((this.$route.hash || '').replace(/^#/, ''))
    if (!this.token) this.erro = 'Link de convite inválido. Peça um novo convite ao administrador.'
    else history.replaceState(null, '', '/rh/aceitar')
  },
  methods: {
    async aceitar() {
      if (!this.token || this.senha !== this.confirmacao) return
      this.salvando = true
      this.erro = ''
      try {
        await http.post('/api/rh/pessoas/convites/aceitar', { token: this.token, senha: this.senha })
        this.token = ''
        this.senha = ''
        this.confirmacao = ''
        this.concluido = true
      } catch (e) {
        this.erro = e && e.data && e.data.erro ? e.data.erro : 'Não foi possível ativar o convite. Peça um novo link.'
      } finally {
        this.salvando = false
      }
    },
  },
}
</script>
<style scoped>
.rh-invite {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f4f3f0, #bfddf5);
  padding: 24px;
  font-family: Montserrat, Arial, sans-serif;
}
.rh-panel {
  background: #fff;
  border-radius: 22px;
  padding: 40px;
  width: min(100%, 480px);
  box-shadow: 0 25px 70px rgba(11, 26, 62, 0.12);
}
.rh-logo {
  width: 220px;
  margin-bottom: 34px;
}
.rh-kicker {
  letter-spacing: 0.14em;
  color: #0e8fa8;
  font-size: 11px;
  font-weight: 800;
}
.rh-panel h1 {
  font-size: 29px;
  color: #0b1a3e;
  font-weight: 800;
  margin: 8px 0;
}
.rh-panel p {
  color: #667085;
  margin-bottom: 24px;
}
.rh-panel .field {
  margin: 17px 0;
}
.rh-panel .button.is-primary {
  background: #007bff;
  border-color: #007bff;
  font-weight: 700;
}
.rh-success {
  text-align: center;
}
.rh-success .icon {
  color: #0e8fa8;
}
@media (max-width: 520px) {
  .rh-panel {
    padding: 28px;
  }
}
</style>
